import api from "./api";

export const getUserAdminData = async (email) => {
  const { data } = await api.get(`/admin/users/${email}/admin-data`);

  return data;
};
